/**
 * Locale: `en`
 */

import type { II18nTimeFormatters } from "@anydo/interfaces";

export const timeFormatters: II18nTimeFormatters = {
  hour: {
    CLOCK_12: "ha",
    CLOCK_24: "H:mm",
  },
  time: {
    CLOCK_12: "h:mmA",
    CLOCK_24: "H:mm",
  },
  timePicker: {
    CLOCK_12: "h:mm A",
    CLOCK_24: "H:mm",
  },
  weekday: "dddd",
  weekdayShort: "ddd",
  month: "MMMM",
  monthShort: "MMM",
  day: "Do",
  dayShort: "D",
  date: {
    DD_MM_YY: "D.M.YYYY",
    MM_DD_YY: "MMM DD, YYYY",
  },
  dateShort: {
    MM_DD_YY: "M.D.YY",
    DD_MM_YY: "D.M.YY",
  },
  dateYearless: {
    MM_DD_YY: "M.D",
    DD_MM_YY: "D.M",
  },
  dateTextField: {
    DD_MM_YY: "D.M.YYYY",
    MM_DD_YY: "M.D.YYYY",
  },
  dateTextFieldFormatters: {
    DD_MM_YY: ["D.M.YYYY", "DD.MM.YYYY", "DD.MMM.YYYY", "YYYY-MM-DD"],
    MM_DD_YY: ["M.D.YYYY", "MM.DD.YYYY", "MMM DD.YYYY", "YYYY-MM-DD"],
  },
  monthYear: "MMMM YYYY",
  today: "dddd, MMMM D",
  isoWeekStartDay: 1, // (Monday). Sunday is the default for USA / Canada, but for us it's important the first business day which is Monday
};
